import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Plus } from "lucide-react";
import { api } from "../../api";
import { APageHead, ATable, ABadge, AMetric } from "../adminKit";

export default function AdminVendors() {
  const [d, setD] = useState({ items: [], tracked_total: 0, disclaimer: "" });
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState({ name: "", website: "", category: "Net-30", net_terms: "Net-30", status: "active", requirements: "" });

  const load = () => api.get("/admin/vendors").then(({ data }) => setD(data));
  useEffect(() => { load(); }, []);
  const create = async () => {
    if (!form.name.trim()) return toast.error("Name required");
    try { await api.post("/admin/vendors", form); setOpen(false); setForm({ name: "", website: "", category: "Net-30", net_terms: "Net-30", status: "active", requirements: "" }); toast.success("Vendor added"); load(); }
    catch { toast.error("Failed"); }
  };
  const archive = async (id) => { try { await api.delete(`/admin/vendors/${id}`); toast.success("Archived"); load(); } catch { toast.error("Failed"); } };

  return (
    <div className="space-y-4">
      <APageHead title="Vendor & Tradeline Directory" subtitle="Central vendor directory for the platform."
        action={<button onClick={() => setOpen(true)} data-testid="vendor-new" className="cc-btn-primary inline-flex items-center gap-2 rounded-xl px-4 py-2 text-sm font-500"><Plus size={15} /> Add Vendor</button>} />
      <div className="grid grid-cols-2 md:grid-cols-3 gap-3">
        <AMetric label="Directory Vendors" value={d.items.length} tone="blue" />
        <AMetric label="User-Tracked Vendors" value={d.tracked_total} tone="purple" />
        <AMetric label="Active" value={d.items.filter((v) => v.status === "active").length} tone="green" />
      </div>
      <div className="rounded-xl border border-amber-500/20 bg-amber-500/[0.06] px-4 py-2.5 text-xs text-amber-200/80">{d.disclaimer}</div>
      <ATable loading={false} rows={d.items} columns={[
        { key: "name", label: "Vendor", render: (r) => <span className="text-white">{r.name}</span> },
        { key: "category", label: "Category", render: (r) => <ABadge tone="blue">{r.category}</ABadge> },
        { key: "net_terms", label: "Terms" },
        { key: "status", label: "Status", render: (r) => <ABadge tone={r.status === "active" ? "green" : "default"}>{r.status}</ABadge> },
        { key: "act", label: "", render: (r) => <button onClick={() => archive(r.id)} className="text-xs text-red-300">Archive</button> },
      ]} empty="No vendors in the directory yet." />

      {open && (
        <div className="fixed inset-0 z-[60] flex items-center justify-center px-4">
          <div className="absolute inset-0 bg-black/60" onClick={() => setOpen(false)} />
          <div className="relative cc-card rounded-2xl p-6 w-full max-w-md space-y-3">
            <h3 className="cc-heading text-lg font-500 text-white">Add Vendor</h3>
            <input placeholder="Vendor name" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} className="cc-input w-full rounded-xl px-4 py-2.5 text-sm" data-testid="vendor-dir-name" />
            <input placeholder="Website" value={form.website} onChange={(e) => setForm({ ...form, website: e.target.value })} className="cc-input w-full rounded-xl px-4 py-2.5 text-sm" />
            <div className="grid grid-cols-2 gap-3">
              <input placeholder="Category" value={form.category} onChange={(e) => setForm({ ...form, category: e.target.value })} className="cc-input rounded-xl px-3 py-2.5 text-sm" />
              <input placeholder="Net terms" value={form.net_terms} onChange={(e) => setForm({ ...form, net_terms: e.target.value })} className="cc-input rounded-xl px-3 py-2.5 text-sm" />
            </div>
            <textarea placeholder="Requirements" value={form.requirements} onChange={(e) => setForm({ ...form, requirements: e.target.value })} rows={2} className="cc-input w-full rounded-xl px-4 py-2.5 text-sm" />
            <button onClick={create} className="cc-btn-primary w-full rounded-xl py-2.5 text-sm font-500" data-testid="vendor-dir-create">Add Vendor</button>
          </div>
        </div>
      )}
    </div>
  );
}
